import {Component, Input} from '@angular/core';
import {FieldTypes} from 'projects/journal/src/_interface/field-types.enum';
import {ControlTemplate} from '../_interface/control-template.enum';
import {WipField} from '../../../../journal/src/_interface/wip-field.interface';
import {UntypedFormArray, Validators} from '@angular/forms';
import {tap} from 'rxjs/operators';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'form-selectable-with-other',
	templateUrl: './selectable-with-other.component.html'
})
export class SelectableWithOtherComponent {
	@Input() set wipField(s: WipField) {
		if (!s) return;
		this.field = s;
		this.type = s.templateField.fieldType;
		this.templateFieldId = s.templateField.templateFieldId;
		this.selectedDescriptionArray = this.field.fieldFormGroup.get('content.selectedDescriptionArray') as UntypedFormArray;
		if (s.templateField.body.isWarning) this.watchForWarningChange();
		if (s.templateField.body.otherOptions?.length) {
			this.getOtherPlaceholders();
			this.listenOtherOptions();
		}
	}

	field: WipField;
	type: FieldTypes;
	types = FieldTypes;
	ControlTemplate = ControlTemplate;
	showSelectedDesc = false;
	wasWarning = false;
	otherPlaceholders: Record<string, string>;
	templateFieldId: string;
	selectedDescriptionArray: UntypedFormArray;
	selectedFlattened: string[];

	private getOtherPlaceholders() {
		const {options, otherPlaceholders} = this.field.templateField.body;
		this.otherPlaceholders = options.reduce((acc, item, index) => ({...acc, [item]: otherPlaceholders[index] || item}), {});
	}

	private listenOtherOptions() {
		const selected = this.field.fieldFormGroup.get('content.selected');
		const {fieldType} = this.field.templateField;
		this.populateSelectedDescription(fieldType);
		selected.valueChanges.pipe(
			untilDestroyed(this),
			tap(() => {
				this.populateSelectedDescription(fieldType);
			})
		).subscribe();
	}

	private populateSelectedDescription(fieldTypes: FieldTypes) {
		const selected = this.field.fieldFormGroup.get('content.selected');
		if (!selected.value) return;
		const otherOptions = this.field.templateField.body.otherOptions;
		switch (fieldTypes) {
			case FieldTypes.checkbox:
				const otherCheckboxRequired = this.field.templateField.body.otherRequired;
				const optionsForCheckbox = otherOptions.map(element => selected?.value.includes(element) ? element : null);
				optionsForCheckbox.map((option: string, index: number) => {
					this.selectedDescriptionArray.at(index)?.get('option').patchValue(option);
					!otherCheckboxRequired || this.selectedDescriptionArray.at(index)?.get('description').setValidators(Validators.required);
					if (!option) this.selectedDescriptionArray.at(index)?.get('description').clearValidators();
					this.selectedDescriptionArray.at(index)?.get('description').updateValueAndValidity();
				});
				break;
			case FieldTypes.multiselect:
				const otherMultiselectRequired = this.field.templateField.body.otherRequired;
				this.selectedFlattened = selected?.value.map((s: {key: string, index: number}) => s.key);
				const optionsForMultiselect = otherOptions.map(element => this.selectedFlattened.includes(element) ? element : null);
				optionsForMultiselect.map((option: string, index: number) => {
					this.selectedDescriptionArray.at(index)?.get('option').patchValue(option);
					!otherMultiselectRequired || this.selectedDescriptionArray.at(index)?.get('description').setValidators(Validators.required);
					if (!option) this.selectedDescriptionArray.at(index)?.get('description').clearValidators();
					this.selectedDescriptionArray.at(index)?.get('description').updateValueAndValidity();
				});
				break;
			case FieldTypes.select:
			case FieldTypes.radio:
				const otherRequired = this.field.templateField.body.otherRequired;
				otherOptions.includes(selected.value) || this.field.fieldFormGroup.get('content.selectedDescription').patchValue(null);
				(!otherRequired && otherOptions.includes(selected.value)) ||
					this.field.fieldFormGroup.get('content.selectedDescription').setValidators(Validators.required);
				if (!otherOptions.includes(selected.value)) this.field.fieldFormGroup.get('content.selectedDescription').clearValidators();
				this.field.fieldFormGroup.get('content.selectedDescription').updateValueAndValidity();
				break;
		}
	}

	private watchForWarningChange = () => {
		const selected = this.field.fieldFormGroup.get('content.selected');
		const isWarningField = this.field.fieldFormGroup.get('content.isWarning');
		const selectedDescription = this.field.fieldFormGroup.get('content.selectedDescription');
		const { warningOption } = this.field.templateField.body;
		this.wasWarning = isWarningField.value && (selected.value !== warningOption);
		selected.valueChanges.subscribe((value: string) => {
			isWarningField.patchValue(warningOption === value);
			selectedDescription.patchValue('');
		});
	}
}

